module.exports = __webpack_public_path__ + "img/blue.0d5045c9.jpeg";